import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase/app";
import { Id } from "../types";

const db = getFirestore(app);
const storeKind = "profiles";

export interface Profile {
  displayName: string;
  description?: string;
}

export async function fetchProfile(userId: Id): Promise<Profile> {
  const docSnap = await getDoc(doc(db, storeKind, userId));
  return docSnap.exists()
    ? ({ ...docSnap.data() } as Profile)
    : { displayName: "" };
}
